import React, { useContext } from "react";
import { MobergCheckbox, MobergColumn, MobergHeader, MobergInputLabel, MobergNumberInput, MobergRow, MobergText } from "../../../../Moberg";
import { ConfigureWindowModalContext } from "./ConfigureWindowModal";
import { SummaryValueConfig } from "../../../../Pages/Data/Visualize/DataReview/Types/Graph";
import { SolidColorTraceDataConfig } from "../../../../Pages/Data/Visualize/DataReview/Types/Trace";

export const MultiGraphNumericDisplayConfiguration = () => {
    const { activeSourceTraces, activeAnalyticTraces, activeDeltaRegions, currentGraph, updateGraphProperty } = useContext(ConfigureWindowModalContext)
    const allTraceOptions: SolidColorTraceDataConfig[] = [...activeSourceTraces, ...activeAnalyticTraces, ...activeDeltaRegions].map(trace => ({ ...trace, color: (trace as SolidColorTraceDataConfig).color ?? "black" })) as SolidColorTraceDataConfig[]
    const updateConfig = (traceId: string, newConfig: SummaryValueConfig | undefined) => {
        updateGraphProperty("traces", (currentGraph?.traces ?? []).map(trace => {
            if (trace.id === traceId) {
                return { ...trace, summaryValueConfig: newConfig }
            }
            return trace
        }))
    }

    const validateDecimalPlaces = (decimalPlaces: number): string | undefined => {
        if (decimalPlaces < 0 || decimalPlaces > 4) {
            return "Enter a number between 0 and 4."
        }
        return undefined
    }

    const validateSummaryValueColumns = (numberOfColumns: number): string | undefined => {
        if (numberOfColumns < 1 || numberOfColumns > 3) {
            return "Enter a number between 1 and 3."
        }
        return undefined
    }

    return (
        <MobergColumn expand={false} gap="16px">
            <MobergHeader>Numeric display</MobergHeader>
            <MobergRow style={{ padding: "0 4px" }}>
                <MobergNumberInput
                    label={"Number of columns"}
                    value={currentGraph?.summaryValueColumns}
                    defaultValue={1}
                    validationFunction={validateSummaryValueColumns}
                    onChange={numberOfColumns => updateGraphProperty("summaryValueColumns", numberOfColumns)}
                />
            </MobergRow>
            <div style={{ display: "grid", gridTemplateColumns: "auto auto auto", columnGap: "16px", rowGap: "12px", padding: "0 4px", maxWidth: "fit-content", alignItems: "center" }}>
                <MobergInputLabel text={"Name"} />
                <MobergInputLabel text={"Decimals"} />
                <MobergInputLabel text={"Visible"} />
                {allTraceOptions.map(trace => {
                    return (<>
                        <MobergText>{trace.name}</MobergText>
                        <MobergNumberInput
                            defaultValue={0}
                            value={trace.summaryValueConfig?.precision ?? 0}
                            validationFunction={validateDecimalPlaces}
                            onChange={precision => updateConfig(trace.id, trace.summaryValueConfig
                                ? { ...trace.summaryValueConfig, precision: precision ?? 0 }
                                : { color: trace.color, name: trace.name, precision: 0, isVisible: false })}
                        />
                        <MobergCheckbox
                            isChecked={trace.summaryValueConfig !== undefined && trace.summaryValueConfig.isVisible}
                            onChange={isVisible => updateConfig(trace.id, trace.summaryValueConfig
                                ? { ...trace.summaryValueConfig, isVisible }
                                : { color: trace.color, name: trace.name, precision: 0, isVisible })}
                        />
                    </>)
                })}
            </div>
        </MobergColumn>
    )
}